<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            <!-- {{ $t('company.vision.title') }} -->
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('company.company.subtitle')}}
          </v-col>
        </v-row>
        <v-row class="mb-4">
          <v-col class="text-justify">
            {{ $t('company.company.text.01')}} <br>
            {{ $t('company.company.text.02')}}
          </v-col>
        </v-row>
        <v-row class="justify-center">

          <!-- TODO rename classes -->
          <div class="grid-container">
            <!-- software development -->
            <div class="grid-box-2 gridyhe-1">
              <v-img class="gr-img" src="@/assets/img/about-company-01.webp">&nbsp;</v-img>
              <div class="gr-info">
                <h3>{{ $t("company.company.breef.01.title") }}</h3>
                <p class="gr-text">{{ $t("company.company.breef.01.text") }}</p>
              </div>
            </div>
            <!-- certified systems -->
            <div class="grid-box-1 gridyhe-1">
              <v-img class="gr-img" src="@/assets/img/about-company-02.webp">&nbsp;</v-img>
              <div class="gr-info">
                <h3>{{ $t("company.company.breef.03.title") }}</h3>
                <p class="gr-text">{{ $t("company.company.breef.03.text") }}</p>
              </div>
            </div>
            <!-- energy managment -->
            <div class="grid-box-1 gridyhe-2">
              <v-img class="gr-img" src="@/assets/img/about-company-03.jpeg">&nbsp;</v-img>
              <div class="gr-info">
                <h3>{{ $t("company.company.breef.04.title") }}</h3>
                <p class="gr-text">{{ $t("company.company.breef.04.text") }}</p>
              </div>
            </div>
            <!-- hardware -->
            <div class="grid-box-2 gridyhe-1">
              <v-img class="gr-img" src="@/assets/img/about-company-04.jpeg">&nbsp;</v-img>
              <div class="gr-info">
                <h3>{{ $t("company.company.breef.02.title") }}</h3>
                <p class="gr-text">{{ $t("company.company.breef.02.text") }}</p>
              </div>
            </div>
            <!-- portfolio -->
            <div class="grid-box-1 gridyhe-1">
              <div class="gr-img" style="background:#252525">&nbsp;</div>
              <div class="gr-info">
                <h3>{{ $t("company.company.breef.05.title") }}</h3>
                <p class="gr-text">{{ $t("company.company.breef.05.text") }}</p>
              </div>
            </div>
            <!-- network -->
            <div class="grid-box-1 gridyhe-1">
              <v-img class="gr-img" src="@/assets/img/about-company-06.webp">&nbsp;</v-img>
              <div class="gr-info">
                <h3>{{ $t("company.company.breef.06.title") }}</h3>
                <p class="gr-text">{{ $t("company.company.breef.06.text") }}</p>
              </div>
            </div>
          </div>

        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Company',
    extends: DataComponentBase,

    data: () => ({
      breef: [
        { title: 'company.company.breef.01' },
        { title: 'company.company.breef.02' },
        { title: 'company.company.breef.03' },
        { title: 'company.company.breef.04' },
        { title: 'company.company.breef.05' },
        { title: 'company.company.breef.06' },
      ],

    }),

    methods: {

    },
  }
</script>
